import axios from "axios";

const API = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URI}/api/statuses`
});

// GET ALL STATUSES
export const getStatuses = async () => {
    const response = await API.get("/");
    return response.data;
};

export default API;
